import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { NavigationProvider } from './contexts/NavigationContext';
import ErrorBoundary from './components/ErrorBoundary';
import AppShell from './components/layout/AppShell';
import Home from './pages/Home';
import Search from './pages/Search';
import Analyzing from './pages/Analyzing';
import Results from './pages/Results';
import Auth from './pages/Auth';
import ProfileNew from './pages/ProfileNew';
import Favorites from './pages/Favorites';
import TextSearchPage from './pages/TextSearchPage';
import StylistChat from './components/StylistChat';
import NotFound from './pages/NotFound';
import Blog from './pages/blog/Blog';
import BlogPost from './pages/blog/BlogPost';
import PartnerApplication from './pages/PartnerApplication';
import Deals from './pages/Deals';

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <AuthProvider>
          <Router>
            <NavigationProvider>
              <Routes>
                {/* Main app routes with AppShell */}
                <Route element={<AppShell />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/search" element={<Search />} />
                  <Route path="/text-search" element={<TextSearchPage />} />
                  <Route path="/analyzing" element={<Analyzing />} />
                  <Route path="/results" element={<Results />} />
                  <Route path="/auth" element={<Auth />} />
                  <Route path="/chat/leo" element={<StylistChat />} />
                  <Route path="/profile" element={<ProfileNew />} />
                  <Route path="/favorites" element={<Favorites />} />
                  <Route path="/saved" element={<Favorites />} />
                  <Route path="/deals" element={<Deals />} />
                  <Route path="/partner/apply" element={<PartnerApplication />} />
                </Route>

                {/* Standalone pages (no AppShell) */}
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />

                {/* 404 */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </NavigationProvider>
          </Router>
        </AuthProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;

